/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_7_TitleInputs */

const en_terms_section_7_title = /** @type {(inputs: Terms_Section_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Third-Party Links`)
};

const lv_terms_section_7_title = /** @type {(inputs: Terms_Section_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Trešo pušu saites`)
};

/**
* | output |
* | --- |
* | "7. Third-Party Links" |
*
* @param {Terms_Section_7_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_7_title = /** @type {((inputs?: Terms_Section_7_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_7_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_7_title(inputs)
	return en_terms_section_7_title(inputs)
});